import React from 'react'

function MyProfile() {
  return (
    <div>MyProfile</div>
  )
}

export default MyProfile